var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative flex-shrink-0 flex h-auto py-1 md:py-4 z-20"
  }, [_c('popup', {
    attrs: {
      "opened": _vm.avisPopupState > -1
    },
    on: {
      "close": function ($event) {
        _vm.avisPopupState = -1;
      }
    }
  }, [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_vm.avisPopupState === 1 ? _c('div', [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n          Donner votre avis\n        ")]), _vm._v(" "), _c('h6', {
    staticClass: "w-full text-center text-indigo-600 mb-10"
  }, [_vm._v("\n          Vous pouvez nous faire part de vos remarques ou suggestions ici,\n          afin d'améliorer votre expérience utilisateur.\n        ")]), _vm._v(" "), _c('form', {
    staticClass: "grid grid-cols-2 gap-x-4 gap-y-10 mb-10",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input-text', {
    staticClass: "md:col-span-1",
    attrs: {
      "name": "Prénom",
      "libelle": "Prénom",
      "value": _vm.formAvis.firstname
    },
    on: {
      "input": function (newValue) {
        _vm.formAvis.firstname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-1",
    attrs: {
      "name": "Nom",
      "libelle": "Nom",
      "value": _vm.formAvis.lastname
    },
    on: {
      "input": function (newValue) {
        _vm.formAvis.lastname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-1",
    attrs: {
      "libelle": "Email",
      "value": _vm.formAvis.email
    },
    on: {
      "input": function (newValue) {
        _vm.formAvis.email = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-1",
    attrs: {
      "libelle": "Téléphone",
      "value": _vm.formAvis.phone,
      "type": "tel",
      "error": true
    },
    on: {
      "input": function (newValue) {
        _vm.formAvis.phone = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "libelle": "Votre avis",
      "value": _vm.formAvis.commentary
    },
    on: {
      "input": function (newValue) {
        _vm.formAvis.commentary = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Envoyer",
      "uppercase": true,
      "spinner": _vm.sending,
      "icon": "plane",
      "right": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        !_vm.sending ? _vm.sendAvis() : null;
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.avisPopupState === 2 ? _c('div', [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n          Votre avis a été envoyé\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-5 items-center"
  }, [_c('h6', {
    staticClass: "text-indigo-600"
  }, [_vm._v("\n            Merci d'avoir pris le temps de nous faire part de votre retour.\n          ")]), _vm._v(" "), _c('illustration', {
    attrs: {
      "name": "basket"
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "ml-6 lg:ml-12 text-indigo-600 focus:outline-none xl:hidden",
    attrs: {
      "aria-label": "Open sidebar"
    },
    on: {
      "click": function ($event) {
        return _vm.openSidebar();
      }
    }
  }, [_c('icon', {
    staticClass: "text-indigo-600 w-5 h-5 lg:w-6 lg:h-6",
    attrs: {
      "name": "menu"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-1 px-2 md:px-4"
  }, [_c('div', {
    staticClass: "flex w-8/12 ml-10 text-pink-600 text-lg items-center"
  }, [(_vm.$trial() && !_vm.$subscription() && [_vm.constants.ROLE_ADMIN_PAYEUR, _vm.constants.ROLE_ADMIN_ENTREPRISE].includes(_vm.role) || _vm.$freeParticulier()) && _vm.currentPage === '/' || _vm.isInCompetencesModule ? _c('banner', {
    staticClass: "hidden lg:block"
  }, [_c('TrialPeriodMessage'), _vm._v(" "), _vm.$freeParticulier() ? _c('div', [_c('p', [_vm._v("\n            Vous êtes actuellement sur une version\n            "), _c('span', {
    staticClass: "uppercase font-semibold"
  }, [_vm._v("bêta")]), _vm._v("\n            qui va évoluer prochainement.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Vos retours sont précieux, n'hésitez pas à nous faire part de\n            votre\n            "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("avis")]), _vm._v(" "), _c('span', {
    staticClass: "underline text-pink-600 cursor-pointer hover:font-semibold",
    on: {
      "click": _vm.displayAvisPopup
    }
  }, [_vm._v("ici")]), _vm._v(".\n          ")])]) : _vm._e(), _vm._v(" "), _vm.isInCompetencesModule ? _c('div', [_c('p', [_vm._v("\n            Le module Compétences est actuellement sur une version\n            "), _c('span', {
    staticClass: "uppercase font-semibold"
  }, [_vm._v("bêta")]), _vm._v("\n            qui va évoluer prochainement.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Vos retours sont précieux, n'hésitez pas à nous faire part de\n            votre\n            "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("avis")]), _vm._v(" "), _c('span', {
    staticClass: "underline text-pink-600 cursor-pointer hover:font-semibold",
    on: {
      "click": _vm.displayAvisPopup
    }
  }, [_vm._v("ici")]), _vm._v(".\n          ")])]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "w-1/3 md:w-1/5 flex items-center justify-evenly"
  }, [_vm.$can('messagerie') ? _c('button', {
    staticClass: "relative p-1 text-indigo-600 rounded-full focus:outline-none tour_messages",
    attrs: {
      "aria-label": "Messages"
    }
  }, [_c('icon', {
    staticClass: "h-8 w-8",
    attrs: {
      "name": "email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute top-0 right-0 block h-4 w-4 rounded-full text-xs text-white bg-pink-600"
  }, [_vm._v("3")])], 1) : _vm._e(), _vm._v(" "), _vm.$can('notifications') ? _c('button', {
    staticClass: "relative p-1 text-indigo-600 rounded-full focus:outline-none tour_notifs",
    attrs: {
      "aria-label": "Notifications"
    }
  }, [_c('icon', {
    staticClass: "h-8 w-8",
    attrs: {
      "name": "bell"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute top-0 right-0 block h-4 w-4 rounded-full text-xs text-white bg-pink-600"
  }, [_vm._v("1")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-start mr-10 w-max"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('button', {
    staticClass: "flex items-center text-left text-2sm rounded-full focus:outline-none",
    attrs: {
      "id": "user-menu",
      "aria-label": "User menu",
      "aria-haspopup": "true"
    },
    on: {
      "click": [_vm.toggle, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_c('profile-picture', {
    attrs: {
      "size": "max-w-10 w-10 h-10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden md:block mx-3"
  }, [_c('p', {
    staticClass: "text-lg leading-5 font-normal text-gray-900"
  }, [_vm._v("\n              " + _vm._s(_vm.user.firstname) + "\n              "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.user.lastname))])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden md:block"
  }, [!_vm.userMenu ? _c('icon', {
    staticClass: "text-pink-600",
    attrs: {
      "name": "chevron-down"
    }
  }) : _c('icon', {
    staticClass: "text-pink-600",
    attrs: {
      "name": "chevron-up"
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "transition ease-out duration-100",
      "enter-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.userMenu,
      expression: "userMenu"
    }],
    staticClass: "origin-top-right absolute right-0 mt-2 rounded-md shadow-lg w-max-content w-max"
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.close,
      expression: "close"
    }],
    staticClass: "w-auto py-4 rounded-2xl bg-white",
    attrs: {
      "role": "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "user-menu"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm.$can(_vm.constants.PERMISSION_PARAMETRE_COMPTE_INFORMATIONS_COMPTE) ? _c('router-link', {
    staticClass: "block px-6 py-2 font-normal text-base text-gray-600 hover:bg-indigo-600 hover:text-white transition ease-in-out duration-150",
    attrs: {
      "to": {
        name: 'Accountinformations'
      },
      "role": "menuitem"
    }
  }, [_vm._v("\n                Paramètres de compte\n              ")]) : _vm._e(), _vm._v(" "), _vm.$freeParticulier() ? _c('router-link', {
    staticClass: "block px-6 py-2 font-normal text-base text-gray-600 hover:bg-indigo-600 hover:text-white transition ease-in-out duration-150",
    attrs: {
      "to": {
        name: 'PermissionsGuests'
      },
      "role": "menuitem"
    }
  }, [_vm._v("\n                Gestion des invités\n              ")]) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_ROLE_LISTE) || _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_REFERENT_LISTE) || _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE) ? _c('router-link', {
    staticClass: "block px-6 py-2 font-normal text-base text-gray-600 hover:bg-indigo-600 hover:text-white transition ease-in-out duration-150",
    attrs: {
      "to": {
        name: 'Permissions'
      },
      "role": "menuitem"
    }
  }, [_vm._v("\n                Gestion, droits et restrictions\n              ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "block w-full px-6 py-2 font-normal text-left text-base text-gray-600 hover:bg-indigo-600 hover:text-white transition ease-in-out duration-150",
    attrs: {
      "role": "menuitem"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                Déconnexion\n              ")])], 1)])])], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }